import { h, Component, Fragment, options } from 'preact';
import SelectorComponent from './selector.component';
import { config } from '../config/config';

export default class GeographySelectorComponent extends Component {
    constructor() {
        super();
        this.state = {
            geographyTypes: []
        };
    }

    changeReportType() {
        // console.log('%cTRACE: changeReportType', 'color: green; font-weight: 900; background: white')
        // data type change update the available filter options and reset most selected filters
        let geographyTypes = [];
        const dataType = this.props.selectedDataType;

        if (dataType) {
            geographyTypes = config.geographyTypes.filter(x => dataType.geoTypes.includes(x.id));
        }

        this.setState({
            geographyTypes
        });
    }

    componentDidUpdate(prevProps) {
        // console.log('%cTRACE: componentDidUpdate', 'color: green; font-weight: 900; background: white')
        if (this.props.selectedDataType !== prevProps.selectedDataType) {
            // only update this if the data types have changed
            this.changeReportType();
        }
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <SelectorComponent
                    options={self.state.geographyTypes}
                    onSelect={(option) => self.props.onSelect(option)}
                    selected={self.props.selectedGeographyType}
                    message="Select Geography Type"
                    ga="QR Menu: Geography Type"
                />
            </Fragment>
        );
    }
}
